export default "__VITE_ASSET__DEnP3OQK__"